import Panel from 'shared/components/panels/Panel';
import {FormattedMessage} from 'react-intl';
import {t, locale} from 'shared/core';

const SUPPORT_CENTRE_BASE_URL = 'https://support.collage.co';

const HelpfulLink = ({articleId, title}) => {
  const url = `${SUPPORT_CENTRE_BASE_URL}/${locale}/articles/${articleId}`;

  return (
    <div>
      <hr className='mxn1 my0'/>
      <div className='py2'>
        <a href={url} target='_blank' rel='noreferrer'>
          {title}
        </a>
      </div>
    </div>
  );
};

const SupportCentreLink = ({collectionId}) => {
  let url = `${SUPPORT_CENTRE_BASE_URL}/${locale}`;

  if (collectionId) {
    url += `/collections/${collectionId}`;
  }

  return (
    <div>
      <a className='flex justify-end align-items-middle' href={url} target='_blank' rel='noreferrer'>
        <FormattedMessage id='components.helper_panel.Support Centre' />
        <i className='material-icons h3 ml1 align-middle'>{'open_in_new'}</i>
      </a>
    </div>
  );
};

const HelperPanelImg = ({img}) => {
  if (!img) return null;

  return (
    <Panel>
      <img src={img} className='full-width full-height' alt='help'/>
    </Panel>
  );
};

const HelperPanelHeader = ({title, descriptionItems = []}) => {
  if (!title && !descriptionItems.length) return null;

  return (
    <div className='mb2'>
      <Panel.Header title={title}/>
      {descriptionItems.map((d, index) => <div key={index} className='jumbo my1'>{d}</div>)}
    </div>
  );
};

const HelperPanelLinks = ({links, collectionId}) => {
  if (!links.length) return null;

  return (
    <div className='mb2'>
      <div className='flex align-items-middle justify-between mb1 waterloo'>
        <FormattedMessage id='components.helper_panel.Helpful Links'/>
        <SupportCentreLink collectionId={collectionId} />
      </div>
      {links.map((link, index) =>
        <HelpfulLink key={index} articleId={link.articleId} title={t(link.title)} />
      )}
    </div>
  );
};

const HelperPanel = ({img, title, descriptionItems, links, collectionId}) => {
  return (
    <div className='mt2 md-mt0'>
      <Panel.Stack>
        <HelperPanelImg img={img} />
        <Panel>
          <div style={{marginBottom: '-1rem'}}>
            <HelperPanelHeader title={title} descriptionItems={descriptionItems} />
            <HelperPanelLinks links={links} collectionId={collectionId} />
          </div>
        </Panel>
      </Panel.Stack>
    </div>
  );
};

HelperPanel.defaultProps = {
  links: []
};

export default HelperPanel;
